export default "__VITE_ASSET__B6WA$Iod__"